<template>
  <div
    class="form-textarea"
    :class="[$attrs.class, { 'form-textarea--invalid': errorMessage.length }]"
  >
    <label v-if="$attrs.label?.length">
      <span
        class="form-textarea__label-wrapper"
        :class="{ 'form-textarea__label-wrapper--invalid': errorMessage.length }"
      >
        <span class="label-title">{{ $attrs.label }}</span>
        <span v-if="$attrs['label-optional']" class="label-subtitle">{{
          $attrs['label-optional']
        }}</span>
      </span>
    </label>
    <sl-textarea
      v-model="localValue"
      v-bind="$attrs"
      label=""
      @keydown.tab="preventTabPropagation"
    />
    <div class="form-textarea__chart-counter">
      <p v-if="$attrs.maxlength > 0">{{ localValue.length }}/{{ $attrs.maxlength }}</p>
    </div>
    <span v-if="errorMessage.length" class="form-textarea__error-message">{{ errorMessage }}</span>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js'

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  error: {
    type: String,
    default: ''
  },
  tabindex: {
    type: String,
    default: '0'
  }
})

const errorMessage = computed(() => props.error)
const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

function preventTabPropagation(event) {
  if (event.key === 'Tab') {
    event.stopPropagation()
  }
}
</script>

<style lang="postcss" scoped src="./FormTextArea.css"></style>
